import { render, staticRenderFns } from "./listdetailedView.vue?vue&type=template&id=4090e8cb&"
import script from "./listdetailedView.vue?vue&type=script&lang=js&"
export * from "./listdetailedView.vue?vue&type=script&lang=js&"
import style0 from "./listdetailedView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
